if(!customElements.get('custom-login')){
    class CustomLogin extends HTMLElement{
        constructor(){
            super();

            this.init();
        }

        init(){
            this.inputWrappers = this.querySelectorAll('.input-wrapper');
            this.inputs = this.querySelectorAll('input, textarea');
            this.inputs.forEach(item => {
              item.addEventListener('focus', this.focusOnInput.bind(this));
              item.addEventListener('focusout', this.focusOutOnInput.bind(this));
              item.addEventListener('input', () => this.focusOnInput.bind(this));
            });

            this.labels = this.querySelectorAll('.input-wrapper label');
            this.labels.forEach(item => {
              item.addEventListener('click', (e) => {
                if(e.currentTarget.closest('.input-wrapper').getAttribute('data-selected') != 'true'){
                  const inputs = e.currentTarget.closest('.input-wrapper').querySelectorAll('input, textarea');
                  inputs.forEach(item => {
                    item.focus();
                  })
                }
              })
            });
        }

        focusOnInput(e){
            this.inputWrappers.forEach(item => {
              var input = item.querySelector('textarea, input');
              if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })
      
            var currentTarget = e.currentTarget;
            var currentTargetInputWrapper = currentTarget.closest('.input-wrapper');
            currentTargetInputWrapper.setAttribute('data-selected', 'true');
          }
      
          focusOutOnInput(){
            this.inputWrappers.forEach(item => {
              var input = item.querySelector('textarea, input');
              if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })
        }
    }

    customElements.define('custom-login', CustomLogin);
}

document.addEventListener('DOMContentLoaded', () => {
  const forgotPasswordLink = document.querySelector('.btn-forgot-password-link');
  const cancelLink = document.querySelector('.btn-login-link');
  forgotPasswordLink.addEventListener('click', (e) => { updateId(e)});
  cancelLink.addEventListener('click', (e) => { updateId(e)});

  function updateId(e) {
      e.preventDefault();
      const href = e.currentTarget.getAttribute('href');
      const targetId = href.replace('#', '');
      const targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      setTimeout(() => {
          history.replaceState(null, '', href);

          targetEl.style.display = 'block';
          if(targetId === 'recover') document.getElementById('login').style.display = 'none';
          else if(targetId === 'login') document.getElementById('recover').style.display = 'none';
      }, 0);
  }
});